import React from "react";
import { ToggleButton, ToggleButtonGroup, ToggleButtonGroupProps } from "@mui/material";

import "./ToggleButtons.scss";

interface ToggleButtonsProps extends ToggleButtonGroupProps {
  clearable?: boolean;
  buttons: Array<{ key?: string; value: string; text: string }>;
}

export const ToggleButtons = (props: ToggleButtonsProps) => {
  const { onChange, buttons, clearable = true, ...toggleButtonGroupProps } = props;
  const { exclusive = true } = toggleButtonGroupProps;

  if (buttons.length < 2) {
    console.log("Toggle Buttons must have at least 2 buttons");
    return null;
  }
  const { 0: first, [buttons.length - 1]: last, ...mid } = buttons;

  return (
    <ToggleButtonGroup
      classes={{ grouped: "toggle_buttons__toggle-btn" }}
      exclusive={exclusive}
      size="small"
      onChange={(e, value) => {
        if ((value || !clearable) && onChange) {
          onChange(e, value);
        }
      }}
      {...toggleButtonGroupProps}
    >
      <ToggleButton sx={{ borderRadius: 80 }} key={first.key || first.value} value={first.value}>
        {first.text}
      </ToggleButton>
      {Object.values(mid).map((btn: any) => (
        <ToggleButton key={btn.key || btn.value} value={btn.value}>
          {btn.text}
        </ToggleButton>
      ))}
      <ToggleButton sx={{ borderRadius: 80 }} key={last.key || last.value} value={last.value}>
        {last.text}
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
